<div class="title-card">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="page-title">{{title}}</h2>
    <button mat-button class="tcb-button" (click)="add()" *ngIf="allowGlobalSettingCreate">
      Add Setting
    </button>
  </div>
</div>
<mat-card>
  <div>
    <table mat-table matSort [dataSource]="dataSource">

      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Value </th>
        <td mat-cell *matCellDef="let element"> {{element.value}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="language">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Language </th>
        <td mat-cell *matCellDef="let element"> {{element.language}} </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Version </th>
        <td mat-cell *matCellDef="let element"> {{element.version}}</td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="allowGlobalSettingEdit || allowGlobalSettingDelete">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="edit(element)" *ngIf="allowGlobalSettingEdit">Edit</button>
            <button class="badge bg-danger color-white" mat-menu-item (click)="delete(element)" *ngIf="allowGlobalSettingDelete">Delete</button>

          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons
      aria-label="Select page of settings">
    </mat-paginator>
  </div>
</mat-card>
